import React from "react";
import { Minus, Plus, Trash2 } from "lucide-react";
import Button from "../../../components/Button";
import styles from "../css/inventoryItemDetail.module.css";

export const IcdModal = ({
  showIcdModal,
  setShowIcdModal,
  icdList,
  decrementCount,
  incrementCount,
  updateIcdAt,
  removeIcdAt,
}) => {
  if (!showIcdModal) return null;

  return (
    <div className={styles.modalOverlay} role="dialog" aria-modal="true">
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>View ICD-10</h2>
          <button
            className={styles.modalCloseBtn}
            onClick={() => setShowIcdModal(false)}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.icdToolbar}>
            <div className={styles.icdCountControl}>
              <button
                type="button"
                className={styles.icdIconBtn}
                onClick={decrementCount}
                aria-label="Decrease"
              >
                <Minus size={16} />
              </button>
              <span className={styles.icdCount}>{icdList.length}</span>
              <button
                type="button"
                className={styles.icdIconBtn}
                onClick={incrementCount}
                aria-label="Increase"
              >
                <Plus size={16} />
              </button>
            </div>
            <div className={styles.icdToolbarLabel}>ICD-10</div>
          </div>
          <div className={styles.icdChipsRow}>
            {icdList.map((code, idx) => (
              <div className={styles.icdChip} key={idx}>
                <input
                  className={styles.icdChipInput}
                  type="text"
                  value={code}
                  onChange={(e) => updateIcdAt(idx, e.target.value)}
                  placeholder="Z4566"
                />
                {icdList.length > 1 && (
                  <button
                    type="button"
                    className={styles.icdDeleteBtn}
                    onClick={() => removeIcdAt(idx)}
                    aria-label="Remove"
                  >
                    <Trash2 size={14} />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.modalFooter}>
          <Button variant="primary" onClick={() => setShowIcdModal(false)}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};
